import { createSlice } from "@reduxjs/toolkit";
import { logInSuccess, signOutSuccess } from "src/modules/auth/duck/actions";

const initialState = {
  byId: {},
  defaultAvatarId: null
};

const avatarSlice = createSlice({
  initialState,
  name: "avatar",
  reducers: {
    saveAvatar(state, { payload }) {
      state.byId[payload.objectId] = payload;
    },
    setDefaultAvatar(state, { payload }) {
      if (state.byId[payload] == null || state.byId[payload].deleted)
        state.defaultAvatarId = null;
      else state.defaultAvatarId = payload;
    },
    deleteAvatar(state, { payload }) {
      state.byId[payload].deleted = true;
      if (state.defaultAvatarId === payload) {
        state.defaultAvatarId = null;
      }
    },
    replaceAvatars(state, { payload }) {
      state.byId = payload;
      if (
        state.byId[state.defaultAvatarId] == null ||
        state.byId[state.defaultAvatarId].deleted
      ) {
        state.defaultAvatarId = null;
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(logInSuccess, () => {
        return initialState;
      })
      .addCase(signOutSuccess, () => {
        return initialState;
      });
  }
});

export { avatarSlice };
export default avatarSlice.reducer;
